import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  selectedIntrest: cacheLs.get_intrest()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
